import { ERealEstateType } from '../../types/suburban';
import { NBSP } from '../symbols';

export const MORTGAGE_LINK =
  'https://www.cian.ru/cf/offer-showcase?banner=header_rural_mortgage&skip_welcome_page=true';

export const REAL_ESTATE_TYPE_TABS = {
  [ERealEstateType.HOUSE]: `Дом на${NBSP}вторичном рынке`,
  [ERealEstateType.COTTAGE]: `Коттедж от застройщика`,
  [ERealEstateType.LAND]: 'Участок',
  [ERealEstateType.TOWNHOUSE]: 'Таунхаус',
  [ERealEstateType.BUILD]: 'Строительство дома',
};
